import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { ToastProvider } from '@/components/ui/Toast';
import { AuthProvider } from '@/features/auth/AuthProvider';

import { createQueryClient } from './queryClient';

const queryClient = createQueryClient();

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {/* AuthProvider sits inside the query client: signing out clears the cache. */}
      <AuthProvider>
        {/* Innermost, so a toast raised while signing out still has somewhere
            to land, and the notifications sit above every route's own layout. */}
        <ToastProvider>{children}</ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
